import {AbstractTaskHandler} from "./AbstractTaskHandler";
import TakipXmlParser from "../../../takip_ac/TakipXmlParser";
import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";

export class UyapHizliTakipAcTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            console.log("UyapHizliTakipAcTaskHandler", task);
            let takip: UyapTakipAc = UyapTakipAc.fromJson(task.data);
            takip.parsedFile = TakipXmlParser.fromJson(task.data.parsedFile);
            console.log("UyapHizliTakipAcTaskHandler takipBaslat başladı");
            await takip.takipBaslat(false,true);
            console.log("UyapHizliTakipAcTaskHandler takipBaslat tamamlandı");
            task.response = takip;
            // UYAP'ta takip açıldı ama kart ya da hash kaydı güncellenemediyse görev hatalı değil
            // eksik biter; uyarı (esas no dahil) açıklamaya da yazılır (DEV-3302).
            task.status = (takip.icraProSenkronHatasi || takip.hashGuncellemeHatasi) ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            if (task.status == TaskDurum.BITTI_EKSIK)
                task.description = takip.eksikBitisAciklamasi();
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message)
        }
    }
}